import {useEffect} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import {useSuiContext} from '@s-ui/react-context'
import IconArrowsReload02 from '@adv-mt/mt-svg-icons/lib/ArrowsReload02'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const BASE_CLASS = 'mt-NetMessageList-chat'

const NetRetryButton = ({chatId, onRetry, retrying}) => {
  const {domain, i18n} = useSuiContext()
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {TRACKING_EVENT_NAMES: {NET_ASSISTANT_RETRY_VIEWED, NET_ASSISTANT_RETRY_CLICKED} = {}} =
    config.get('tracking') || {}

  useEffect(() => {
    track({
      event: NET_ASSISTANT_RETRY_VIEWED,
      data: {hit_information: chatId}
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClickRetry = () => {
    onRetry()
    track({
      event: NET_ASSISTANT_RETRY_CLICKED,
      data: {hit_information: chatId}
    })
  }

  return (
    <AtomButton
      isLoading={retrying}
      onClick={onClickRetry}
      shape={atomButtonShapes.CIRCULAR}
      design={atomButtonDesigns.OUTLINE}
      size={atomButtonSizes.LARGE}
      className={`${BASE_CLASS}-retryButton`}
      rightIcon={<IconArrowsReload02 />}
    >
      {i18n.t('COMMON.RETRY')}
    </AtomButton>
  )
}

NetRetryButton.displayName = 'NetRetryButton'
NetRetryButton.propTypes = {
  chatId: PropTypes.string,
  onRetry: PropTypes.func,
  retrying: PropTypes.bool
}

export default NetRetryButton
